module.exports = __webpack_public_path__ + "img/step_1.2cf07035.webp";